export default "__VITE_ASSET__BkLGD_Ha__"